import { BaseModel } from './base';
import { User } from './user';

export class UserNotification extends BaseModel {
    public static PARSE_CLASSNAME = 'UserNotification';

    private _user: User;
    private _type: string;
    private _title: string;
    private _message: string;
    private _data: any;
    private _readAt: Date;
    private _sourceOrderId: string;

    constructor() {
        super(UserNotification.PARSE_CLASSNAME);
    }

    public get user(): User {
        return this._user;
    }

    public set user(value: User) {
        this._user = value;
    }

    public get type(): string {
        return this._type;
    }

    public set type(value: string) {
        this._type = value;
    }

    public get title(): string {
        return this._title;
    }

    public set title(value: string) {
        this._title = value;
    }

    public get message(): string {
        return this._message;
    }

    public set message(value: string) {
        this._message = value;
    }

    public get data(): any {
        return this._data;
    }

    public set data(value: any) {
        this._data = value;
    }

    public get readAt(): Date {
        return this._readAt;
    }

    public set readAt(value: Date) {
        this._readAt = value;
    }

    public get sourceOrderId(): string {
        return this._sourceOrderId;
    }

    public set sourceOrderId(value: string) {
        this._sourceOrderId = value;
    }
}

BaseModel.registerClass(UserNotification, UserNotification.PARSE_CLASSNAME);
